import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function siteRegionListHasErrored(bool) {
  return {
    type: 'SITE_REGION_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function siteRegionListIsLoading(bool) {
  return {
    type: 'SITE_REGION_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function siteRegionListFetchDataSuccess(siteRegionList) {
  return {
    type: 'SITE_REGION_LIST_FETCH_DATA_SUCCESS',
    siteRegionList,
  };
}

export function regionListHasErrored(bool) {
  return {
    type: 'REGION_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function regionListIsLoading(bool) {
  return {
    type: 'REGION_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function regionListFetchDataSuccess(regionList) {
  return {
    type: 'REGION_LIST_FETCH_DATA_SUCCESS',
    regionList,
  };
}

export function siteRegionAddHasErrored(bool) {
  return {
    type: 'SITE_REGION_ADD_ERRORED',
    hasErrored: bool,
  };
}

export function siteRegionAdding(bool) {
  return {
    type: 'SITE_REGION_ADD_SAVING',
    isLoading: bool,
  };
}

export function siteRegionAddSuccess(bool) {
  return {
    type: 'SITE_REGION_ADD_SUCCESS',
    isSiteRegionSaveSuccess: bool,
  };
}

export function siteRegionUpdateHasErrored(bool) {
  return {
    type: 'SITE_REGION_UPDATE_ERRORED',
    hasErrored: bool,
  };
}

export function siteRegionUpdating(bool) {
  return {
    type: 'SITE_REGION_UPDATE_SAVING',
    isLoading: bool,
  };
}

export function siteRegionUpdateSuccess(bool) {
  return {
    type: 'SITE_REGION_UPDATE_SUCCESS',
    isSiteRegionSaveSuccess: bool,
  };
}

export function dealFunderListHasErrored(bool) {
  return {
    type: 'DEAL_FUNDER_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}

export function dealFunderListIsLoading(bool) {
  return {
    type: 'DEAL_FUNDER_LIST_IS_LOADING',
    isLoading: bool,
  };
}

export function dealFunderListFetchDataSuccess(dealFunderList) {
  return {
    type: 'DEAL_FUNDER_LIST_FETCH_DATA_SUCCESS',
    dealFunderList,
  };
}

export function allSiteRegionsFetchData() {
  const url = apiEndPoints.ALL_SITE_REGION_ITEM_LIST;

  return (dispatch) => {
    dispatch(siteRegionListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(siteRegionListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(siteRegionListFetchDataSuccess(items)))
      .catch(() => dispatch(siteRegionListHasErrored(true)));
  };
}

export function siteRegionListFetchData(funderId, regionId) {
  let url = '';

  if (funderId) {
    url = apiEndPoints.SITE_REGION_ITEM_LIST.replace('funderId', funderId);
  } else {
    url = apiEndPoints.ALL_SITE_REGION_ITEM_LIST;
  }

  if (regionId > 0) {
    if (!url.includes('?')) {
      url += '?';
    } else {
      url += '&';
    }

    url += 'regionId=' + regionId;
  }

  return (dispatch) => {
    dispatch(siteRegionListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(siteRegionListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(siteRegionListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(siteRegionListHasErrored(true));
        dispatch(siteRegionListIsLoading(false));
      });
  };
}

export function regionListFetchData(funderId) {
  let url = '';

  if (funderId) {
    url = apiEndPoints.REGION_ITEM_LIST.replace('funderId', funderId);
  } else {
    url = apiEndPoints.ALL_REGION_ITEM_LIST;
  }

  return (dispatch) => {
    dispatch(regionListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(regionListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(regionListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(regionListHasErrored(true));
        dispatch(regionListIsLoading(false));
      });
  };
}

export function addSiteRegionData(siteId, regionId, funderId) {
  const url = apiEndPoints.SITE_REGION_ADD;

  return (dispatch) => {
    dispatch(siteRegionAdding(true));

    adalApiFetch(fetch, url, {
      method: 'POST', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify({
        siteId: siteId,
        regionId: regionId,
        funderId: funderId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(siteRegionAdding(false));

        return response;
      })
      //.then((response) => response.json())
      .then(() => dispatch(siteRegionAddSuccess(true)))
      .then(() => dispatch(siteRegionListFetchData(funderId)))
      .catch(() => {
        dispatch(siteRegionAddHasErrored(true));
        dispatch(siteRegionAdding(false));
      });
  };
}

export function updateSiteRegionData(siteRegionId, regionId, funderId) {
  const url = apiEndPoints.SITE_REGION_UPDATE.replace(
    'siteRegionId',
    siteRegionId,
  );
  // url = url + "?regionId=" + regionId;
  return (dispatch) => {
    dispatch(siteRegionUpdating(true));

    adalApiFetch(fetch, url, {
      method: 'PUT', // or "PUT"
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify({ regionId: regionId }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(siteRegionUpdating(false));

        return response;
      })
      //.then((response) => response.json())
      .then(() => dispatch(siteRegionUpdateSuccess(true)))
      .then(() => dispatch(siteRegionListFetchData(funderId)))
      .catch(() => {
        dispatch(siteRegionUpdateHasErrored(true));
        dispatch(siteRegionUpdating(false));
      });
  };
}

export function dealFunderListFetchData() {
  const url = apiEndPoints.FUNDER_ITEM_LIST;
  return (dispatch) => {
    dispatch(dealFunderListFetchDataSuccess([]));
    dispatch(dealFunderListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(dealFunderListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(dealFunderListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(dealFunderListHasErrored(true));
        dispatch(dealFunderListIsLoading(false));
      });
  };
}

export function dealFunderListWithRegionsFetchData() {
  const url = apiEndPoints.FUNDER_ITEM_LIST_WITH_REGIONS;
  return (dispatch) => {
    dispatch(dealFunderListFetchDataSuccess([]));
    dispatch(dealFunderListIsLoading(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        dispatch(dealFunderListIsLoading(false));

        return response;
      })
      .then((response) => response.json())
      .then((items) => dispatch(dealFunderListFetchDataSuccess(items)))
      .catch(() => {
        dispatch(dealFunderListHasErrored(true));
        dispatch(dealFunderListIsLoading(false));
      });
  };
}
